import Sidebar from '../components/Sidebar';

function MainLayout({
  children,
  isDesktopMode = false,
  userRole,
  onRoleChange,
  roleLocked,
  sidebarUnreadTotals,
  authUser,
  onLogout,
  deviceStatus,
  callState,
  agentId,
  agentStatus,
  onRetryVoice,
  availabilityStatus,
  availabilityOptions = [],
  onAvailabilityStatusChange,
  isUpdatingStatus = false,
  statusUpdateError = '',
}) {
  return (
    <div className="app-root">
      <div className="app-shell">
        <Sidebar
          isDesktopMode={isDesktopMode}
          userRole={userRole}
          onRoleChange={onRoleChange}
          roleLocked={roleLocked}
          unreadTotals={sidebarUnreadTotals}
          authUser={authUser}
          onLogout={onLogout}
          deviceStatus={deviceStatus}
          callState={callState}
          agentId={agentId}
          agentStatus={agentStatus}
          onRetryVoice={onRetryVoice}
          availabilityStatus={availabilityStatus}
          availabilityOptions={availabilityOptions}
          onAvailabilityStatusChange={onAvailabilityStatusChange}
          isUpdatingStatus={isUpdatingStatus}
          statusUpdateError={statusUpdateError}
        />
        <main className="app-main">
          {children}
        </main>
      </div>
    </div>
  );
}

export default MainLayout;

